// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2CLkT","footer":"styles_footer__3sCCG","button":"styles_button__1if1k"};